import { DataBean } from "../../DataBean";


export class PharmaLaboratory extends DataBean {

    public async getPharmaLaboratoryCatalog(regexStr: any, page: any, recordsPerPage: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getPharmaLaboratoryCatalog_String_Number_Number", [regexStr, page, recordsPerPage]);
    }

}